module.exports = __webpack_public_path__ + "static/img/honor14.a64d5d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor14.png
// module id = KYZ1
// module chunks = 0